<template>
  <div>
    <div class="feature-top">
      <product-feature-summary
        :imagePath="'/static/products/coco-call/feature/summary.jpg'"
        :altText="`コードレス呼出しチャイムのコココール`"
        :headerText="
          `呼び出しを確実に伝えてくれるコードレス・チャイム・システム`
        "
        :detailText="
          `受信表示機の表示窓に角度がついているので番号が見やすくなっています。防水構造で衝撃にも強い送信機は、
          豊富な機能で業務を強力にサポートします。`
        "
        :color="'blue'"
      />

      <div class="feature-title">
        安心してご利用いただける 4 つの特徴
      </div>

      <div class="feature-contents">
        <div class="feature-content" style="margin-top: 0;">
          <content-header
            headingTitle="1"
            headingTitleRadius="0"
            title="ノイズ対策にも配慮した安心の小電力タイプ"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <img
            v-lazy="'/static/products/coco-call/feature/feature_01.png'"
            style="top: -50px; width: 35%; height: auto;"
          />
          <div style="width: 70%;">
            <p>
              広い範囲にも対応できる特定小電力タイプを採用。
            </p>
            <p>
              ノイズ対策にも配慮し、さまざまなエリアで安心してご利用いただくことが可能です。
            </p>
          </div>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="2"
            headingTitleRadius="0"
            title="LED 照明の影響を受けにくい安心設計"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            従来の LED( 発光ダイオード )
            照明で発生する電磁波の影響により、ワイヤレス機器は通信トラブルを起すことが少なくありませんでした。
          </p>
          <p>
            コココールはこの問題をクリア。安心してご利用いただけます。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="3"
            headingTitleRadius="0"
            title="安心の混信 / 誤作動の防止機能"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            チャンネル変更するだけで混線を防止できるので、近隣でコココールが使用されていても安心して利用できます。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="4"
            headingTitleRadius="0"
            title="停電にも安心のバックアップ機能"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            万が一の停電時も、記録された呼出し番号や各種設定をしっかりと記憶しています。
          </p>
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <span class="circle-heading-title"> 主な機能 </span>
        </div>
      </div>

      <div class="main-function blue">
        <div class="body">
          <div class="product-block">
            <content-header
              headingTitle="受信表示機"
              headingTitleRadius="0"
              title="角度がついて表示も見やすく、電波の強度も表示機から確認することができます。"
              withBorder="true"
              fontColor="black"
              borderColor="blue"
            />

            <div class="functions">
              <img
                v-lazy="'/static/products/coco-call/feature/function_01.png'"
                style="width: 40%; height: 100%;"
                :style="this.$isPC ? '' : 'width: 100%;'"
              />

              <div class="function">
                <div style="width: 60%; display: inline-block;">
                  <div class="function-title">
                    見やすさがアップ！
                  </div>
                  <div class="function-detail">
                    下向設計の表示窓を採用することで数字をより大きく表示。<br />
                    壁への設置でも下から見やすくなりました。
                  </div>
                </div>
                <img
                  v-lazy="'/static/products/coco-call/feature/function_02.png'"
                  style="width: 35%; display: inline-block;"
                />
              </div>

              <div class="function">
                <div class="function-title">
                  先着順番号表示
                </div>
                <div class="function-detail">
                  受信表示機のディスプレイには、呼び出した送信機の番号を先着順で表示。<br />
                  対応する順番をしっかり把握できます。
                </div>
              </div>

              <div class="function">
                <div class="function-title">
                  かんたん設定を実現
                </div>
                <div class="function-detail">
                  呼び出し番号やチャイム音などを送信機側で簡単に設定することが可能になりました。使い方に合わせて、最適な設定で使用することができるので、サービスを効率よく提供できます。
                </div>
              </div>

              <div class="function">
                <div class="function-title">
                  急ぎの呼び出しがスグわかる
                </div>
                <div class="function-detail">
                  同じ送信機からの呼び出しを複数回キャッチすると、受信表示機の表示番号は点灯表示から点滅表示に変化します。<br />
                  早く対応した方がよい番号がひと目でわかるので大変便利です。
                </div>
              </div>

              <div class="function">
                <div class="function-title">
                  受信毎にチャイム音の有無を設定
                </div>
                <div class="function-detail">
                  受信表示機は、送信機からの信号受信毎にチャイム音の有無を設定することが可能。あらかじめチャイム音に関するルールを設定しておくことで、効率の良いサービスを行えます。
                </div>
              </div>

              <div class="function">
                <div class="function-title">
                  対応遅れを予防する、経過時間お知らせ機能
                </div>
                <div class="function-detail">
                  表示されている呼び出し番号は、一定時間が経過すると点滅表示となります。<br />
                  さらに、時間の経過に伴い点滅するスピードが4段階で変化していきます。
                </div>
              </div>

              <div class="function">
                <div class="function-title">
                  電波の状態を目視で確認可能
                </div>
                <div class="function-detail">
                  受信表示機に、送信機からの電波強度表示機能（数字表示）を搭載。送信機を実際のテーブルに置いてテストを実施し、電波が届きにくい場所は事前に対策を行うことで安心して運用することが可能です。
                </div>
              </div>

              <div class="function">
                <div class="function-title">
                  多彩な取付スタイルに対応
                </div>
                <div class="function-detail">
                  本体内に収納できるタイプの吊下げ用フックを標準で装備。<br />
                  天井吊下げや壁取付、台置きなど、受信表示機を最も見やすい場所に、しっかりと確実に設置することが可能になっています。
                </div>
              </div>
            </div>
          </div>

          <div class="product-block">
            <content-header
              headingTitle="携帯受信機"
              headingTitleRadius="0"
              title="持ちやすさと操作のしやすさを両立。見やすさにもこだわった携帯タイプの受信表示機。"
              withBorder="true"
              fontColor="black"
              borderColor="blue"
            />
            <div style="display: flex; justify-content: space-between;">
              <img
                v-lazy="'/static/products/coco-call/feature/function_03.png'"
                style="width: 15%; height: 100%;"
              />
              <div class="vertical-functions">
                <div class="function">
                  <div class="function-title">
                    呼び出しをわかりやすくお知らせ
                  </div>
                  <div class="function-detail">
                    呼び出し受信時にはチャイム音とバイブレーション（振動）でお知らせ。<br />
                    また、呼び出しを受信すると番号表示と同時に受信ランプが点滅。呼び出しをわかりやすくお知らせします。
                  </div>
                </div>
                <div class="function">
                  <div class="function-title">
                    2窓3色表示
                  </div>
                  <div class="function-detail">
                    2か所からの呼び出しもしっかり表示。それ以上の呼び出しがあった場合にはメモリに記録し、順次表示します。<br />
                    また 3 色の LED により表示番号の色分け表示を実現。<br />
                    それぞれの色と場所を関連づけておくことにより、どこから呼び出されたかがひと目で把握できます。
                  </div>
                </div>
                <div class="function">
                  <div class="function-title">
                    連続待受30時間＆約6時間でフル充電
                  </div>
                  <div class="function-detail">
                    バッテリーロングライフ設計により、連続待受時間30時間（イヤホンを使用しない時）を実現。<br />
                    携帯受信表示機のフル充電に掛かる時間は約6時間です。<br />
                    <span style="font-size: 11px;">
                      ※連続待受時間は、電波を正常に受信できる静止状態での平均的な利用時間です。<br />
                      &nbsp;&nbsp;&nbsp;充電状態・気温などの使用環境、利用場所の電波状態などによっては、ご利用時間が短くなることがあります。
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="product-block">
            <content-header
              headingTitle="送信機"
              headingTitleRadius="0"
              title="送信機は丸型、スタンダード型、カード型もご用意しています！"
              withBorder="true"
              fontColor="black"
              borderColor="blue"
            />

            <div style="display: flex; justify-content: space-between;">
              <div style="width: 19%;">
                <img
                  v-lazy="'/static/products/coco-call/feature/function_07.png'"
                  style="width: 100%; background-color: white; border: 1px solid rgb(145, 162, 170);"
                />
                <p style="margin: 0; font-size: 14px;">丸型</p>
              </div>
              <div style="width: 19%;">
                <img
                  v-lazy="'/static/products/coco-call/feature/function_08.png'"
                  style="width: 100%; background-color: white; border: 1px solid rgb(145, 162, 170);"
                />
                <p style="margin: 0; font-size: 14px;">丸型ナプキン付</p>
              </div>
              <div style="width: 19%;">
                <img
                  v-lazy="'/static/products/coco-call/feature/function_09.png'"
                  style="width: 100%; background-color: white; border: 1px solid rgb(145, 162, 170);"
                />
                <p style="margin: 0; font-size: 14px;">スタンダード型</p>
              </div>
              <div style="width: 19%;">
                <img
                  v-lazy="'/static/products/coco-call/feature/function_10.png'"
                  style="width: 100%; background-color: white; border: 1px solid rgb(145, 162, 170);"
                />
                <p style="margin: 0; font-size: 14px;">
                  スタンダード<br />ナプキンスタンド型
                </p>
              </div>
              <div style="width: 19%;">
                <img
                  v-lazy="'/static/products/coco-call/feature/function_11.png'"
                  style="width: 100%; background-color: white; border: 1px solid rgb(145, 162, 170);"
                />
                <p style="margin: 0; font-size: 14px;">カード型</p>
              </div>
            </div>
          </div>

          <div class="product-block">
            <content-header
              headingTitle="中継機"
              headingTitleRadius="0"
              title="より広い場所でご利用いただくことが可能になります。"
              withBorder="true"
              fontColor="black"
              borderColor="blue"
            />
            <div style="display: flex; justify-content: space-between;">
              <div style="width: 60%; text-align: center;">
                <img
                  v-lazy="'/static/products/coco-call/feature/function_12.png'"
                  style="width: 100%; height: auto;"
                />
                <p
                  style="margin: 0; color: rgb(16, 106, 203); font-weight: bold;"
                >
                  数値で電波の強度が簡単に確認できます
                </p>
              </div>

              <div class="vertical-functions">
                <div class="function">
                  <div class="function-title">
                    信号の到達範囲を拡大
                  </div>
                  <div class="function-detail">
                    中継機の利用で、信号の到達範囲を拡大することが可能。より広い場所でご利用いただくことが可能になります。
                  </div>
                </div>
                <div class="function">
                  <div class="function-title">
                    同一チャンネルで複数の中継機を設置可能
                  </div>
                  <div class="function-detail">
                    広いエリアで通信を行うことが可能。また入り組んだ施設内等でも、電波を遮る壁などを避けるように中継機を設置することで、安心して通信が行えます。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="column_nav">
      <h2 style="color: #0a518d">おすすめのコンテンツ</h2>
      <ul
        style="width: 100%; max-width: 960px; margin: 0 auto; box-sizing: border-box;"
      >
        <li>
          <a href="/choice/industry/3" target="_blank"
            ><img
              src="/static/columns/14/factory_mv.png"
              alt="工場の呼出しベルについて"
          /></a>

          <h3>
            <a href="/choice/industry/3" target="_blank"
              >工場の呼出しベルについて</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/5" target="_blank"
            ><img
              src="/static/columns/5/img_nursecall_easytopush1.jpg"
              alt="ナースコールを押しやすい環境づくりの方法を5パターンに分けて解説"
          /></a>

          <h3>
            <a href="/column/5" target="_blank"
              >ナースコールを押しやすい環境づくりの方法を5パターンに分けて解説</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/8" target="_blank"
            ><img
              src="/static/columns/8/img_factory_trouble_improvement1.jpg"
              alt="業務・環境改善で工場トラブルを減らす！代表的なトラブルと対処法も"
          /></a>

          <h3>
            <a href="/column/8" target="_blank"
              >業務・環境改善で工場トラブルを減らす！代表的なトラブルと対処法も</a
            >
          </h3>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ProductFeatureSummary from '@/components/modules/ProductFeatureSummary'
import ContentHeader from '@/components/modules/ContentHeader'

export default {
  components: {
    ProductFeatureSummary,
    ContentHeader,
  },
}
</script>

<style scoped>
.feature-section .header h2 {
  color: rgb(16, 106, 203);
}

.feature-title {
  font-size: 20px;
  font-weight: bold;

  display: inline-block;

  margin: 30px 0 10px;
  padding: 0 25px;

  color: white;
  border-radius: 20px;
  background-color: rgb(16, 106, 203);
}

.sp-product .feature-content {
  margin: 20px 0;
}

.feature-section .main-function {
  background-color: rgb(242, 246, 250);
}

.feature-section .main-function .body {
  width: 90%;
  max-width: 1100px;
}

.feature-section .main-function .body .product-block {
  width: 100%;
  margin: 20px 0;
}

.feature-section .main-function .body .product-block .content-header {
  font-size: 18px;

  margin-bottom: 20px;
}

.feature-section .main-function .body .functions {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.sp-product .feature-section .main-function .body .functions {
  flex-direction: column;
}

.feature-section .main-function .body .functions .function {
  width: 45%;
  margin-bottom: 10px;

  border: none;
}

.sp-product .feature-section .main-function .body .functions .function {
  width: 100%;
}

.function .function-title {
  padding-bottom: 5px;

  border-bottom: 1px solid rgb(178, 194, 201);
}

.feature-section .main-function .body .vertical-functions {
  display: inline-block;

  width: 80%;
}

.feature-section .main-function .body .vertical-functions .function {
  margin-bottom: 10px;

  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/products/features/CocoCall.vue